export default __webpack_public_path__ + "static/media/entity-circle.82552cee.svg";